"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 14 8" id=icon-chevron-up-small><path d="M13 8a1.006 1.006 0 01-.714-.29L6.972 2.404 1.658 7.71c-.399.34-.993.317-1.364-.053a.999.999 0 01-.052-1.359L6.269.291a1.007 1.007 0 011.416 0l6.028 6.007a.999.999 0 01.21 1.087c-.156.37-.52.613-.923.615z"></path></symbol>';
};